import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn } from "react-feather";
import man from "../../../assets/images/dashboard/profile.png";
import { LI, UL, Image, P } from "../../../AbstractElements";
import { LogOut } from "../../../Constant";

const UserHeader = () => {
  const history = useNavigate();
  const [profile, setProfile] = useState("");
  const [name, setName] = useState("Test User");
  const [userRole, setUserRole] = useState("User");
  const authenticated = JSON.parse(localStorage.getItem("authenticated"));
  const auth0_profile = JSON.parse(localStorage.getItem("auth0_profile"));

  useEffect(() => {
    const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
    setProfile(localStorage.getItem("profileURL") || man);
    setName(authUser.fullName || "Test User");
    setUserRole(authUser.role || "User");
  }, []);

  const Logout = () => {
    localStorage.clear();
    history(`${process.env.PUBLIC_URL}/login`);
  };

  return (
    <li className="profile-nav onhover-dropdown pe-0 py-0">
      <div className="media profile-media">
        <Image
          attrImage={{
            className: "b-r-10 m-0",
            src: authenticated ? auth0_profile?.picture || man : profile || man,
            alt: "",
          }}
        />
        <div className="media-body">
          <span>{authenticated ? auth0_profile?.name || name : name}</span>
          <P attrPara={{ className: "mb-0 font-roboto" }}>
            {userRole} <i className="middle fa fa-angle-down"></i>
          </P>
        </div>
      </div>
      <UL
        attrUL={{ className: "simple-list profile-dropdown onhover-show-div" }}
      >
        <LI attrLI={{ onClick: Logout }}>
          <LogIn />
          <span>{LogOut}</span>
        </LI>
      </UL>
    </li>
  );
};

export default UserHeader;
